import type { State } from '../../types';
import type { GuidelineViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function guidelinesNotDeleted(state: State): GuidelineViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.guidelinesById).filter((e) => !e.deleted);
}
